export const scrollToFirstError = ({
  errors = {},
  touched = {},
  errorSelectors = [],
  offset = 100,
  delay = 300
}) => {
  setTimeout(() => {
    let firstErrorElement = null;

    if (Object.keys(errors).length > 0 && Object.keys(touched).length > 0) {
      const errorFields = Object.keys(errors).filter(
        (key) => errors[key] && touched[key]
      );

      if (errorFields.length > 0) {
        const firstErrorField = errorFields[0];
        const errorMessage = errors[firstErrorField];

        const allErrorElements = Array.from(
          document.querySelectorAll(
            '[class*="ErrorSign"], [class*="ErrorSignWrapper"], [class*="Error"], [class*="error"]'
          )
        );

        const foundErrorElement = allErrorElements.find((element) => {
          const text = element.textContent || element.innerText || '';
          return text.trim() && text.includes(errorMessage);
        });

        if (foundErrorElement) {
          firstErrorElement = foundErrorElement;
        }

        if (!firstErrorElement) {
          const selectors = [
            `[name="${firstErrorField}"]`,
            `#${firstErrorField}`,
            `[data-field="${firstErrorField}"]`
          ];

          const foundInputElement = selectors
            .map((selector) => document.querySelector(selector))
            .find((element) => element !== null);

          if (foundInputElement) {
            firstErrorElement = foundInputElement;
          }
        }

        if (!firstErrorElement) {
          const inputElement = document.querySelector(
            `[name="${firstErrorField}"]`
          );
          if (inputElement) {
            const errorWrapper = inputElement.closest(
              '[class*="Error"], [class*="error"], [class*="Field"], [class*="Container"]'
            );
            if (errorWrapper) {
              firstErrorElement = errorWrapper;
            } else {
              firstErrorElement = inputElement;
            }
          }
        }
      }
    }

    if (!firstErrorElement && errorSelectors.length > 0) {
      const foundElement = errorSelectors
        .map((selector) => {
          try {
            return document.querySelector(selector);
          } catch (e) {
            return null;
          }
        })
        .find((element) => element !== null && element.offsetParent !== null);

      if (foundElement) {
        firstErrorElement = foundElement;
      }
    }

    if (!firstErrorElement) {
      const errorElements = Array.from(
        document.querySelectorAll(
          '[class*="ErrorSign"], [class*="ErrorSignWrapper"], [class*="Error"], [class*="error"]'
        )
      );

      const foundElement = errorElements.find(
        (element) =>
          element.offsetParent !== null && element.textContent?.trim()
      );

      if (foundElement) {
        firstErrorElement = foundElement;
      }
    }

    if (firstErrorElement) {
      try {
        const elementRect = firstErrorElement.getBoundingClientRect();
        const elementTop = elementRect.top + window.pageYOffset;
        const elementHeight = elementRect.height;
        const windowHeight = window.innerHeight;

        const scrollPosition =
          elementTop - windowHeight / 2 + elementHeight / 2;

        window.scrollTo({
          top: Math.max(0, scrollPosition),
          behavior: 'smooth'
        });
      } catch (e) {
        firstErrorElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest'
        });
      }
    }
  }, delay);
};

export default scrollToFirstError;
